import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/css/Form.css';
import logo from '../assets/images/Logo.svg';
import check from '../assets/images/check.svg';

function VerifyEmail() {
	let navigate = useNavigate();

	const handleEmail = e => {
		e.preventDefault();
		navigate(`/login`);
	};

	return (
		<div className='main-container form-bg-color form-bg-log'>
			<img src={logo} className='form-logo' alt='logo' />
			<div className='form-container'>
				<img
					src={check}
					style={{
						height: '7vmin',
						pointerEvents: 'none',
						marginBottom: '7px',
					}}
					alt='logo'
				/>
				<div className='form-label2-vmn'>Verification Email Sent!</div>
				<span
					style={{
						color: '#000',
						fontSize: '14px',
						margin: '10px 0px',
						display: 'block',
					}}
				>
					Please check your email.
				</span>
				<button type='submit' onClick={handleEmail} className='btn-send-code'>
					GO TO LOGIN
				</button>
			</div>
		</div>
	);
}

export default VerifyEmail;
